import type { BackgroundJob } from "./BackgroundJob";

export type BackgroundJobScheduleFrequency = "MINUTES" | "HOURLY" | "DAILY";

/** MINUTES's intervals — they land on the clock (:00, :15, …). */
export const BACKGROUND_JOB_SCHEDULE_INTERVALS = [5, 10, 15, 20, 30];

/**
 * A schedule's editable settings (times in Sydney): MINUTES every intervalMinutes, HOURLY at :minute,
 * DAILY at time (HH:mm) on weekdays (1 = Mon … 7 = Sun; empty = every day).
 */
export interface BackgroundJobScheduleInput {
  name: string;
  kind: string;
  frequency: BackgroundJobScheduleFrequency;
  intervalMinutes: number | null;
  minute: number | null;
  time: string | null;
  weekdays: number[];
  enabled: boolean;
}

/** A background job on a schedule, fired by AWS EventBridge Scheduler. */
export interface BackgroundJobSchedule extends BackgroundJobScheduleInput {
  id: string;
  /** ISO; undefined while switched off. */
  nextRunAt?: string;
  lastJob?: BackgroundJob;
}
